var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"caseLink"}},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.returnTop('#caseList')}}},[_vm._v("典型案例")]),_c('li',{on:{"click":function($event){return _vm.returnTop('#caseSearch')}}},[_vm._v("全部案例")]),_c('li',{on:{"click":function($event){return _vm.returnTop('#customerContainer')}}},[_vm._v("重要客户及合作单位")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }